import axios from 'axios';
import moment from 'moment';
import { api, DATE_TIME_FORMAT_24 } from '../../utils/Constants';
import { updateAxiosToken } from './apiService';

export async function getTrips(params) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.trips}`;

  try {
    const response = await axios.get(url, { params: params });
    return response.status === 400 ? [] : response.data;
  }
  catch (error) {
    console.log(error);
    return [];
  }
}

export async function getTripsMultiple(tripNumber) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.tripsMultiple}/${tripNumber}`;

  try {
    const response = await axios.get(url);
    return response.status === 400 ? [] : response.data;
  }
  catch (error) {
    console.log(error);
    return [];
  }
}

export async function getTrip(tripId) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.trips}/${tripId}`;
  const response = await axios.get(url)

  return response.data;
}

export async function getExceptions(params) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.tripsExceptions}`;

  try {
    const response = await axios.get(url, { params: params });

    return response.status === 400 ? [] : response.data;
  }
  catch (error) {
    return [];
  }
}

export async function cancelTrip(tripId) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.events}`;
  const data = createPostEventData(tripId, 'cancel', null);
  const response = await axios.post(url, data);

  return response;
}

export async function confirmProvider(tripId, driverId) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.events}`;
  const data = createPostEventData(tripId, 'confirm', driverId);
  const response = await axios.post(url, data);

  return response;
}

export async function removeProvider(tripId) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.events}`;
  const data = {
    eventType: 'unconfirm',
    tripId: parseInt(tripId),
  };

  const response = await axios.post(url, data);

  return response;
}

export async function resolveException(exceptionId, operation) {
  const url = `${api.url}${api.methods.exceptions}/${exceptionId}?operation=${operation}`;
  const response = await axios.patch(url);

  return response;
}

export async function reserveException(exceptionId, operation) {
  const url = `${api.url}${api.methods.exceptions}/${exceptionId}?operation=${operation}`;
  return await axios.patch(url);
}

export async function reserveAllExceptions(data) {
  const url = `${api.url}${api.methods.exceptionsByTrip}`;
  return await axios.patch(url,data);
}

export async function patchTripNotes(data) {
  const url = `${api.url}${api.methods.trips}/${data.tripId}`
  const response = await axios.patch(url, data);
  return response;
}

export async function patchTrip(tripId, minutes, notes) {
  const url = `${api.url}${api.methods.trips}/${tripId}`
  const data = {
    waitMinutes: minutes,
    notes: notes,
  }

  const response = await axios.patch(url, data);
  return response;
}

export async function patchCancelTrip(tripId, reasonId) {
  const url = `${api.url}${api.methods.trips}/${tripId}`
  const data = {
    Intent: "tripStatusUpdate",
    TripStatus: 'Canceled',
    TripStatusReasonId: reasonId
  }

  const response = await axios.patch(url, data);
  return response;
}

//Possible status: 'None,Inactive,Activated'
export async function patchTripWillCall(tripId, willCall) {
  const url = `${api.url}${api.methods.trips}/${tripId}`
  const data = {
    intent: "willCallUpdate",
    willCallStatus: willCall
  }

  const response = await axios.patch(url, data);
  return response;
}

function createPostEventData(tripId, eventType, driverId, pickupTimeZone) {

  return {
    eventType: eventType,
    tripId: parseInt(tripId),
    time: moment().utc().format(`${DATE_TIME_FORMAT_24} Z`),
    driverId: parseInt(driverId),
  }
}

export async function postEvent(tripId, eventType, time, lat, lon) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.events}`;
  const data = {
    eventType: eventType,
    tripId: tripId,
    time: time,
    lat: lat,
    lon: lon
  }

  const response = await axios.post(url, data);

  return response;
}
